import React from 'react';
import { Section, WhatsAppButton } from './Shared';
export function Hero() {
  return <Section bg="dark" className="relative overflow-hidden pt-20 pb-24 md:pt-32 md:pb-32" data-id="element-89">
      <div className="relative z-10 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-90">
        <div className="text-center lg:text-left space-y-8" data-id="element-91">
          <h1 className="text-4xl md:text-5xl lg:text-5xl xl:text-6xl font-bold leading-tight tracking-tight text-white" data-id="element-92">
            ¿Sabes exactamente cuánto recibirás de pensión el día que dejes de
            trabajar?
          </h1>

          <p className="text-lg md:text-xl text-slate-300 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-93">
            Auditamos tu historia laboral, recuperamos tus semanas perdidas y te
            decimos el valor que recibirás. Sin filas. Sin abogados costosos.
            Directo a tu WhatsApp.
          </p>

          <div className="pt-4 flex flex-col items-center lg:items-start gap-3" data-id="element-94">
            <WhatsAppButton text="QUIERO MI ASESORÍA PENSIONAL — ESCRÍBENOS POR WHATSAPP" size="lg" className="w-full sm:w-auto text-sm sm:text-base" data-id="element-95" />
            <span className="text-sm text-slate-400 font-medium" data-id="element-96">
              (Respuesta inmediata)
            </span>
          </div>
        </div>

        <div className="relative" data-id="element-97">
          <img src="https://cdn.magicpatterns.com/uploads/131GsUiqdEZPwx8JJum1ZS/Imagen_2_pagina_Solucion_a_Pension.png" alt="Analista pensional revisando una proyección de mesada y la historia laboral de un cliente" className="w-full rounded-2xl shadow-2xl ring-1 ring-white/10 object-cover" loading="eager" data-id="element-98" />
        </div>
      </div>
    </Section>;
}